import React, { useEffect, useState, useRef } from "react";
import AddFormLibrary from "./AddFormLibrary";
import Moment from "react-moment";
import ViewFormModal from "../../ReviewTools/ViewFormModal";
import { useDispatch, useSelector } from "react-redux";
import {
  allowFormLibraryEdit, deleteFormLibrary, getAppFormLibrary,
  getAppFormLibraryDeleteStatus, getAppFormLibrarySendStatus,
  getFormLibraryEditStatus, loadAppLibraryForms, sendFormLibraryToApplicant,
  getAppFormLibraryLoading, getAppFormLibrarySendLoading, getAppFormLibraryDeleteLoading
} from "../../app/store/forms";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import NotesPopover from "../../comman/NotesPopover";

const FormsLibrary = (props) => {
  const { workflowTask, setViewBprmFormShowHide, handleUpdateComponent } = props;

  const [appFormLibrary, setAppFormLibrary] = useState([]);
  const [selectedKey, setSelectedKey] = useState("home");
  const [selectedFormId, setSelectedFormId] = useState(0);
  const [selectedForm, setSelectedForm] = useState(null);
  const [viewFormShowHide, setViewFormShowHide] = useState(false);
  const [updateCompStatus, setUpdateCompStatus] = useState(false);

  const appFormLibrarySelector = useSelector(getAppFormLibrary);
  const appFormLibrarySendStatusSelector = useSelector(getAppFormLibrarySendStatus);
  const appFormLibraryDeleteStatusSelector = useSelector(getAppFormLibraryDeleteStatus);
  const formLibraryEditStatusSelector = useSelector(getFormLibraryEditStatus);
  const isLoading = useSelector(getAppFormLibraryLoading);
  const isSendLoading = useSelector(getAppFormLibrarySendLoading);
  const isDeleteLoading = useSelector(getAppFormLibraryDeleteLoading);

  const [sendingFormId, setSendingFormId] = useState(null);
  const [deletingFormId, setDeletingFormId] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (workflowTask?.ciid > 0) {
      dispatch(loadAppLibraryForms(workflowTask.ciid));
      setUpdateCompStatus(true);
    }
  }, []);

  useEffect(() => {
    if (appFormLibrarySelector.length > 0) {
      const frmLibrary = appFormLibrarySelector
        .filter(x => x.formType !== "ACH Information" && x.formType !== "Insurance Information");
      setAppFormLibrary(frmLibrary);
      let frmItems = "";
      frmLibrary.map((x, key) => {
        if (key > 0) frmItems += ",";
        frmItems += x.id;
      });
      if (updateCompStatus) {
        handleUpdateComponent(frmItems);
        setUpdateCompStatus(false);
      }
    } else {
      setAppFormLibrary([]);
    }
  }, [appFormLibrarySelector]);

  const handleSelectTab = (tab) => {
    setSelectedKey(tab);
  };

  const handleResetSelection = () => {
    setSelectedFormId(0);
    setSelectedForm(null);
  };

  const handleSelectForm = (frm) => {
    if (selectedFormId === frm.id) {
      handleResetSelection();
    } else {
      setSelectedForm(frm);
      setSelectedFormId(frm.id);
    }
  };

  const getPopover = (notes, placement = "top") => {
    return <NotesPopover notes={notes} placement={placement} />;
  };

  const handleDeleteForm = async (id) => {
    const result = await getConfirmAlert("", "Are you sure you want to Delete this Form?", "warning");
    if (result.isConfirmed) {
      setDeletingFormId(id);
      dispatch(deleteFormLibrary(id));
    }
  };

  useEffect(() => {
    if (appFormLibraryDeleteStatusSelector) {
      setDeletingFormId(null);
      getAlert("", "Deleted Successfully", "success");
      if (workflowTask?.ciid) {
        dispatch(loadAppLibraryForms(workflowTask.ciid));
        setUpdateCompStatus(true);
      }
      handleResetSelection();
    }
  }, [appFormLibraryDeleteStatusSelector]);

  const handleAllowForm = async (f, allow) => {
    const result = await getConfirmAlert("", `Are you sure you want to give permission ${allow === 1 ? "to Edit" : "to Edit not allow"
      } this Form?`, "warning");

    if (result.isConfirmed) {
      dispatch(allowFormLibraryEdit(f.id, allow, ""));
    }
  };

  useEffect(() => {
    if (formLibraryEditStatusSelector) {
      getAlert("", "Applied Successfully", "success");
      if (workflowTask?.ciid) dispatch(loadAppLibraryForms(workflowTask.ciid));
    }
  }, [formLibraryEditStatusSelector]);

  const handleSendForm = (id) => {
    setSendingFormId(id);
    dispatch(sendFormLibraryToApplicant(id));
  };

  useEffect(() => {
    if (appFormLibrarySendStatusSelector) {
      setSendingFormId(null);
      getAlert("", "Sent Successfully", "success");
      if (workflowTask?.ciid) dispatch(loadAppLibraryForms(workflowTask.ciid));
    }
  }, [appFormLibrarySendStatusSelector]);

  const handleAddFormLibrary = (isUpdated = false) => {
    setSelectedKey("home");
    setSelectedFormId(0);
    setSelectedForm(null);
    if (isUpdated && workflowTask?.ciid > 0) {
      dispatch(loadAppLibraryForms(workflowTask.ciid));
      setUpdateCompStatus(true);
    }
  };

  const handleViewFormShowHide = (f) => {
    setViewFormShowHide(!viewFormShowHide);
    setViewBprmFormShowHide(!viewFormShowHide);
    setSelectedForm(f);
  };

  const renderSelectedFormCard = () => {
    if (selectedFormId === 0 || !selectedForm) return null;

    const isUpdated = selectedForm.updatedCount > 0;

    return (
      <div className="rt-msg-selected-card">
        <div className="rt-msg-selected-info">
          <div className="rt-msg-selected-avatar">
            <i className="fa fa-file-text-o" aria-hidden="true" style={{ fontSize: "20px" }} />
          </div>
          <div className="rt-msg-selected-meta">
            <strong>{selectedForm.formName}</strong>
            <span>
              <i className="fa fa-info-circle" aria-hidden="true" />
              Form ID #{selectedFormId}
              <span>&bull;</span>
              <span className={`rt-form-status-tag ${isUpdated ? "is-updated" : "is-pending"}`}>
                {isUpdated ? "Updated" : "Pending"}
              </span>
            </span>
          </div>
        </div>
        <div className="rt-msg-selected-actions">
          <button
            className="rt-form-action-btn is-view-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleViewFormShowHide(selectedForm);
            }}
            type="button"
          >
            <i className="fa fa-eye" aria-hidden="true" /> View
          </button>
          <button
            className="rt-form-action-btn is-view"
            onClick={() => handleSelectTab("profile")}
            type="button"
          >
            <i className="fa fa-pencil" aria-hidden="true" /> Edit Form
          </button>
          <button
            className="rt-form-action-btn is-delete"
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteForm(selectedForm.id);
            }}
            type="button"
            title="Delete Form"
          >
            <i className="fa fa-trash-o" aria-hidden="true" /> Delete
          </button>
          <button
            className="rt-form-action-btn is-clear"
            onClick={handleResetSelection}
            type="button"
            title="Clear selection"
          >
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="rt-form-workbench">
        <style>{`
          :root {
            --primary-color: #2563eb;
            --primary-hover: #1d4ed8;
            --primary-soft: #eff6ff;
            --secondary-color: #64748b;
            --secondary-hover: #475569;
            --border-color: #e2e8f0;
            --bg-light: #f8fafc;
            --text-main: #1e293b;
            --text-muted: #64748b;
          }

          .rt-form-workbench {
            background: transparent !important;
            color: #334155 !important;
            --task-accent: #2563eb !important;
            --task-soft: #eff6ff !important;
            position: relative;
          }

          @keyframes loadingBar {
            0%   { width: 0%; opacity: 1; }
            70%  { width: 85%; opacity: 1; }
            100% { width: 100%; opacity: 0; }
          }

          .wf-loading-bar {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            height: 3px !important;
            background: linear-gradient(90deg, #2563eb, #7c3aed, #2563eb) !important;
            background-size: 200% 100% !important;
            animation: loadingBar 1.6s ease-in-out infinite !important;
            z-index: 10 !important;
          }

          @keyframes shimmer {
            0%   { background-position: -600px 0; }
            100% { background-position: 600px 0; }
          }

          .skeleton-cell {
            display: block;
            height: 13px;
            border-radius: 6px;
            background: linear-gradient(
              90deg,
              #f1f5f9 25%,
              #e2e8f0 50%,
              #f1f5f9 75%
            );
            background-size: 600px 100%;
            animation: shimmer 1.4s ease-in-out infinite;
          }

          .skeleton-cell.sk-short  { width: 40%; }
          .skeleton-cell.sk-medium { width: 65%; }
          .skeleton-cell.sk-long   { width: 85%; }
          .skeleton-cell.sk-full   { width: 92%; }

          .skeleton-row td {
            padding: 14px 16px !important;
          }

          .rt-msg-tab-bar {
            display: flex;
            align-items: stretch;
            gap: 4px;
            border-bottom: 2px solid #f1f5f9;
            margin-bottom: 12px !important;
            padding: 8px 4px 0;
            position: relative;
          }

          .rt-msg-tab-btn {
            position: relative;
            display: inline-flex;
            align-items: center;
            gap: 7px;
            border: none;
            background: transparent;
            padding: 9px 16px 11px;
            font-size: 13.5px;
            font-weight: 600;
            color: #64748b;
            cursor: pointer;
            border-radius: 8px 8px 0 0;
            transition: color 0.2s ease, background 0.2s ease;
            outline: none;
            white-space: nowrap;
          }
          .rt-msg-tab-btn i {
            font-size: 13px;
            transition: color 0.2s ease;
          }
          .rt-msg-tab-btn:hover {
            color: #1e293b;
            background: rgba(37,99,235,0.04);
          }
          .rt-msg-tab-btn:focus,
          .rt-msg-tab-btn:focus-visible,
          .rt-msg-tab-btn:active {
            outline: none !important;
            box-shadow: none !important;
            border-color: transparent !important;
          }
          .rt-msg-tab-btn.active {
            color: var(--task-accent, #2563eb);
            font-weight: 700;
          }
          .rt-msg-tab-btn.active i {
            color: var(--task-accent, #2563eb);
          }
          .rt-msg-tab-btn::after {
            content: "";
            position: absolute;
            bottom: -2px;
            left: 0;
            right: 0;
            height: 2px;
            background: var(--task-accent, #2563eb);
            border-radius: 2px 2px 0 0;
            transform: scaleX(0);
            transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .rt-msg-tab-btn.active::after {
            transform: scaleX(1);
          }
          .rt-msg-tab-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 20px;
            height: 20px;
            padding: 0 6px;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 700;
            background: #f1f5f9;
            color: #64748b;
            border: 1px solid #e2e8f0;
            line-height: 1;
            transition: all 0.2s ease;
          }
          .rt-msg-tab-btn.active .rt-msg-tab-badge {
            background: var(--task-soft, rgba(37,99,235,0.1));
            color: var(--task-accent, #1d4ed8);
            border-color: var(--task-accent, rgba(37,99,235,0.2));
          }

          .rt-msg-panel {
            animation: rtMsgTabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both !important;
            flex: 1 1 auto !important;
            min-height: auto !important;
            overflow-y: visible !important;
            overflow-x: hidden !important;
            padding-top: 4px !important;
            padding-right: 4px !important;
          }
          .rt-msg-panel.is-form-panel {
            padding-top: 4px !important;
          }
          @keyframes rtMsgTabFadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .rt-msg-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            gap: 8px !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            padding: 8px 16px !important;
            border-radius: 8px !important;
            font-size: 13px !important;
            font-weight: 600 !important;
            color: #475569 !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            outline: none !important;
            white-space: nowrap !important;
          }
          .rt-msg-action-btn:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .rt-msg-action-btn.is-primary {
            background: var(--task-accent, #2563eb) !important;
            color: #ffffff !important;
            border-color: var(--task-accent, #2563eb) !important;
          }
          .rt-msg-action-btn.is-primary:hover {
            background: var(--task-accent, #2563eb) !important;
            color: #ffffff !important;
            transform: translateY(-1px) !important;
            opacity: 0.9 !important;
            box-shadow: 0 4px 10px -1px var(--task-accent, rgba(37, 99, 235, 0.25)) !important;
          }
          .rt-msg-action-btn.btn-danger-search {
            background: rgba(239, 68, 68, 0.06) !important;
            color: #dc2626 !important;
            border: 1px solid rgba(239, 68, 68, 0.18) !important;
          }
          .rt-msg-action-btn.btn-danger-search:hover {
            background: rgba(239, 68, 68, 0.12) !important;
            color: #b91c1c !important;
            border-color: rgba(239, 68, 68, 0.28) !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 8px -2px rgba(239, 68, 68, 0.12) !important;
          }

          .rt-msg-selected-card {
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 20px !important;
            padding: 18px 22px !important;
            margin: 0 0 12px 0 !important;
            border: 1px solid rgba(37,99,235,0.12) !important;
            border-radius: 14px !important;
            background: linear-gradient(135deg, rgba(37,99,235,0.04) 0%, rgba(124,58,237,0.03) 100%) !important;
            flex-wrap: wrap !important;
            animation: rtMsgTabFadeIn 0.3s ease both !important;
          }
          .rt-msg-selected-info {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            min-width: 0 !important;
          }
          .rt-msg-selected-avatar {
            width: 46px !important;
            height: 46px !important;
            border-radius: 12px !important;
            background: linear-gradient(135deg, #2563eb, #7c3aed) !important;
            color: #ffffff !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            font-size: 18px !important;
            font-weight: 800 !important;
            flex-shrink: 0 !important;
            box-shadow: 0 4px 10px rgba(37,99,235,0.2) !important;
            border: 2px solid #ffffff !important;
          }
          .rt-msg-selected-meta {
            display: flex !important;
            flex-direction: column !important;
            gap: 4px !important;
            min-width: 0 !important;
          }
          .rt-msg-selected-meta strong {
            display: block !important;
            color: #1e293b !important;
            font-size: 14px !important;
            font-weight: 700 !important;
            margin-bottom: 3px !important;
          }
          .rt-msg-selected-meta span {
            color: #64748b !important;
            font-size: 12px !important;
            font-weight: 500 !important;
            display: flex !important;
            align-items: center !important;
            gap: 7px !important;
            flex-wrap: wrap !important;
          }
          .rt-msg-selected-actions {
            display: flex !important;
            align-items: center !important;
            gap: 8px !important;
            flex-wrap: wrap !important;
            flex-shrink: 0 !important;
          }
          .rt-msg-selected-actions .rt-form-action-btn {
            height: 38px !important;
            box-sizing: border-box !important;
            justify-content: center !important;
          }
          .rt-msg-selected-actions .rt-form-action-btn.is-clear {
            min-width: auto !important;
            width: 38px !important;
            padding: 0 !important;
          }

          .rt-msg-table-scroll {
            overflow: auto !important;
            max-height: 460px !important;
            border-radius: 0.375rem !important;
            position: relative !important;
            scrollbar-width: thin !important;
            scrollbar-color: #94a3b8 #f1f5f9 !important;
          }
          .rt-msg-table {
            width: 100%;
            margin-bottom: 0;
            margin-top: 0px !important;
            border: none;
            border-collapse: separate;
            border-spacing: 0;
            color: var(--text-main, #1e293b);
          }
          .rt-msg-table thead {
            position: sticky;
            top: 0;
            z-index: 2;
            background: var(--bg-light, #f8fafc);
          }
          .rt-msg-table thead tr th:first-child {
            border-top-left-radius: 0.375rem !important;
          }
          .rt-msg-table thead tr th:last-child {
            border-top-right-radius: 0.375rem !important;
          }
          .rt-msg-table thead th {
            color: var(--text-muted, #64748b);
            font-size: 11.5px;
            font-weight: 700;
            letter-spacing: 0.05em;
            text-transform: uppercase;
            padding: 12px 16px;
            border-top: none;
            border-bottom: 1px solid var(--border-color, #e2e8f0);
            white-space: nowrap;
          }
          .rt-form-workbench .rt-msg-table td {
            padding: 14px 16px;
            font-size: 13.5px;
            color: var(--text-main, #1e293b);
            vertical-align: middle;
            border-top: none;
            border-bottom: 1px solid var(--border-color, #e2e8f0);
            background: transparent !important;
            background-color: transparent !important;
            transition: all 0.15s ease;
          }
          .rt-form-workbench .rt-msg-table tbody tr:last-child td {
            border-bottom: none;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row {
            cursor: pointer;
            transition: transform 0.1s ease !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row:active {
            transform: scaleY(0.98) !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row:hover td {
            background-color: rgba(37, 99, 235, 0.04) !important;
            color: #1e293b !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row:hover td:first-child {
            box-shadow: inset 3px 0 0 0 rgba(37, 99, 235, 0.35) !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row td {
            background-color: rgba(37, 99, 235, 0.07) !important;
            color: #1e3a8a !important;
            font-weight: 500 !important;
            border-bottom: 1px solid rgba(37, 99, 235, 0.08) !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row td:first-child {
            box-shadow: inset 4px 0 0 0 #2563eb !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row:hover td {
            background-color: rgba(37, 99, 235, 0.09) !important;
          }

          .rt-msg-email {
            display: inline-flex !important;
            align-items: center !important;
            gap: 5px !important;
            color: var(--text-muted, #64748b) !important;
            font-size: 11.5px !important;
            font-weight: 500 !important;
            margin-top: 2px !important;
          }
          .rt-msg-time {
            display: flex !important;
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 2px !important;
          }
          .rt-msg-time-row {
            display: flex !important;
            align-items: center !important;
            gap: 6px !important;
          }
          .rt-msg-time-date {
            font-weight: 600 !important;
            color: #1e293b !important;
          }
          .rt-msg-time-subtext {
            font-size: 11.5px !important;
            color: var(--text-muted, #64748b) !important;
            padding-left: 30px !important;
          }
          .rt-msg-time-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            border-radius: 6px;
            background: var(--bg-light, #f8fafc);
            color: var(--text-muted, #64748b);
            font-size: 12px;
          }
          .rt-msg-empty-state {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 220px;
            padding: 36px 20px;
            text-align: center;
            background: #ffffff;
            border-radius: 12px;
          }
          .rt-msg-empty-icon {
            width: 48px;
            height: 48px;
            border-radius: 12px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: var(--primary-soft, #eff6ff);
            color: var(--primary-color, #2563eb);
            font-size: 20px;
            margin-bottom: 16px;
          }
          .rt-msg-empty-title { margin: 0; color: var(--text-main, #1e293b); font-size: 15px; font-weight: 700; }
          .rt-msg-empty-desc { margin: 6px 0 0; color: var(--text-muted, #64748b); font-size: 13px; }

          .wf-name-cell {
            display: flex !important;
            align-items: center !important;
            gap: 10px !important;
            min-width: 190px !important;
          }
          .wf-name-avatar {
            width: 34px !important;
            height: 34px !important;
            border-radius: 10px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            background: linear-gradient(135deg, rgba(37,99,235,0.12), rgba(20,184,166,0.1)) !important;
            border: 1px solid rgba(37,99,235,0.16) !important;
            color: #1d4ed8 !important;
            font-size: 12px !important;
            font-weight: 800 !important;
            flex-shrink: 0 !important;
          }
          .wf-name-meta {
            display: flex !important;
            flex-direction: column !important;
            gap: 2px !important;
            min-width: 0 !important;
          }
          .wf-name-main {
            font-weight: 700 !important;
            color: #1e293b !important;
            font-size: 13.5px !important;
            line-height: 1.2 !important;
          }
          .wf-name-title {
            font-size: 11.5px !important;
            color: #64748b !important;
            font-weight: 500 !important;
            line-height: 1.2 !important;
          }
          .wf-empty-value {
            color: #cbd5e1 !important;
            font-size: 11.5px !important;
            font-weight: 500 !important;
            line-height: 1.2 !important;
          }

          .rt-form-status-tag {
            font-size: 9px !important;
            font-weight: 800 !important;
            text-transform: uppercase !important;
            padding: 2px 6px !important;
            border-radius: 4px !important;
            letter-spacing: 0.02em !important;
            display: inline-block !important;
          }
          .rt-form-status-tag.is-updated {
            background: #ecfdf5 !important;
            color: #065f46 !important;
            border: 1px solid #a7f3d0 !important;
          }
          .rt-form-status-tag.is-pending {
            background: #fffbeb !important;
            color: #92400e !important;
            border: 1px solid #fde68a !important;
          }
          .rt-form-status-tag.is-allowed {
            background: #eff6ff !important;
            color: #1e40af !important;
            border: 1px solid #bfdbfe !important;
          }
          .rt-form-status-tag.is-requested {
            background: #fef2f2 !important;
            color: #991b1b !important;
            border: 1px solid #fca5a5 !important;
          }

          .custom-radio-wrapper {
            position: relative !important;
            width: 16px !important;
            height: 16px !important;
          }
          .custom-radio-wrapper input {
            position: absolute !important;
            opacity: 0 !important;
            cursor: pointer !important;
            width: 100% !important;
            height: 100% !important;
            margin: 0 !important;
            z-index: 2 !important;
          }
          .custom-radio-checkmark {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            height: 16px !important;
            width: 16px !important;
            background-color: #ffffff !important;
            border: 2px solid #cbd5e1 !important;
            border-radius: 50% !important;
            z-index: 1 !important;
            transition: all 0.2s ease !important;
          }
          .custom-radio-wrapper:hover input ~ .custom-radio-checkmark {
            border-color: var(--task-accent, #3b82f6) !important;
          }
          .custom-radio-wrapper input:checked ~ .custom-radio-checkmark {
            border-color: var(--task-accent, #3b82f6) !important;
            background-color: var(--task-accent, #3b82f6) !important;
          }
          .custom-radio-checkmark:after {
            content: "" !important;
            position: absolute !important;
            display: none !important;
            top: 4px !important;
            left: 4px !important;
            width: 4px !important;
            height: 4px !important;
            border-radius: 50% !important;
            background: #ffffff !important;
          }
          .custom-radio-wrapper input:checked ~ .custom-radio-checkmark:after {
            display: block !important;
          }

          .rt-form-remarks {
            font-size: 11px !important;
            color: #475569 !important;
            line-height: 1.4 !important;
            background: #f8fafc !important;
            padding: 4px 8px !important;
            border-radius: 6px !important;
            border-left: 3px solid #cbd5e1 !important;
            display: inline-block !important;
          }

          .rt-form-buttons-row {
            display: flex !important;
            align-items: center !important;
            gap: 6px !important;
            flex-wrap: wrap !important;
          }
          .rt-form-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 7px !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            padding: 7px 12px !important;
            border-radius: 8px !important;
            font-size: 12px !important;
            font-weight: 600 !important;
            color: #475569 !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            outline: none !important;
            white-space: nowrap !important;
            min-width: 90px !important;
          }
          .rt-form-action-btn:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1.5px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .rt-form-action-btn.is-delete {
            border-color: #ef4444 !important;
            color: #ef4444 !important;
            min-width: auto !important;
          }
          .rt-form-action-btn.is-delete:hover {
            background: #ef4444 !important;
            color: #ffffff !important;
            border-color: #ef4444 !important;
            box-shadow: 0 4px 10px -1px rgba(239, 68, 68, 0.25) !important;
          }
          .rt-form-action-btn.is-view,
          .rt-form-action-btn.is-view-btn {
            border-color: var(--task-accent, #3b82f6) !important;
            color: var(--task-accent, #3b82f6) !important;
          }
          .rt-form-action-btn.is-view:hover,
          .rt-form-action-btn.is-view-btn:hover {
            background: var(--task-accent, #3b82f6) !important;
            color: #ffffff !important;
            border-color: var(--task-accent, #3b82f6) !important;
            box-shadow: 0 4px 10px -1px rgba(59, 130, 246, 0.25) !important;
          }
          .rt-form-name-link {
            font-weight: 600 !important;
            color: var(--task-accent, #2563eb) !important;
            font-size: 14px !important;
            text-align: left !important;
            text-decoration: none !important;
            display: inline-flex !important;
            align-items: center !important;
            text-transform: none !important;
            background: transparent !important;
            border: none !important;
            padding: 0 !important;
            box-shadow: none !important;
            cursor: pointer !important;
            transition: color 0.2s ease !important;
          }
          .rt-form-name-link .rt-form-name-text {
            text-decoration: none !important;
            transition: text-decoration 0.2s ease !important;
          }
          .rt-form-name-link:hover .rt-form-name-text {
            color: var(--primary-hover, #1d4ed8) !important;
            text-decoration: underline !important;
          }
          .rt-form-name-link:focus {
            outline: none !important;
            box-shadow: none !important;
          }
          .rt-action-badge {
            background: #ef4444 !important;
            color: #ffffff !important;
            font-size: 10px !important;
            font-weight: 700 !important;
            width: 18px !important;
            height: 18px !important;
            border-radius: 50% !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            margin-left: 6px !important;
            line-height: 1 !important;
          }
          .rt-form-action-btn.is-send {
            border-color: #10b981 !important;
            color: #10b981 !important;
          }
          .rt-form-action-btn.is-send:hover {
            background: #10b981 !important;
            color: #ffffff !important;
            border-color: #10b981 !important;
            box-shadow: 0 4px 10px -1px rgba(16, 185, 129, 0.25) !important;
          }
          .rt-form-action-btn:disabled {
            opacity: 0.65 !important;
            cursor: not-allowed !important;
            pointer-events: none !important;
            transform: none !important;
            box-shadow: none !important;
          }
          .rt-action-label-badge {
            font-size: 12px !important;
            font-weight: 600 !important;
            text-transform: uppercase !important;
            padding: 7px 12px !important;
            border-radius: 8px !important;
            letter-spacing: 0.02em !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 7px !important;
            min-width: 90px !important;
          }
          .rt-action-label-badge.is-sent {
            background: #ecfdf5 !important;
            color: #065f46 !important;
            border: 1px solid #a7f3d0 !important;
          }
          .rt-action-label-badge.is-allowed {
            background: #eff6ff !important;
            color: #1e40af !important;
            border: 1px solid #bfdbfe !important;
          }
          .rt-form-action-btn.is-allow {
            border-color: #f59e0b !important;
            color: #d97706 !important;
          }
          .rt-form-action-btn.is-allow:hover {
            background: #f59e0b !important;
            color: #ffffff !important;
            border-color: #f59e0b !important;
            box-shadow: 0 4px 10px -1px rgba(245, 158, 11, 0.25) !important;
          }
          
          .rt-edit-request-group {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            gap: 2px !important;
          }
          .rt-edit-req-tag {
            font-size: 8px !important;
            font-weight: 800 !important;
            color: #ef4444 !important;
            text-transform: uppercase !important;
          }
          .rt-msg-table th .rt-th-id-wrapper {
            display: flex !important;
            align-items: center !important;
            gap: 8px !important;
          }
          .rt-msg-table th .rt-id-reset-btn {
            cursor: pointer !important;
            display: inline-flex !important;
            align-items: center !important;
          }
          .rt-msg-table th .rt-id-reset-btn i {
            font-size: 11px !important;
            color: var(--task-accent, #2563eb) !important;
          }
          .rt-msg-id-cell-span {
            font-weight: 700 !important;
            color: #475569 !important;
            font-size: 13px !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
          }
          .selected-row .rt-msg-id-cell-span {
            color: var(--task-accent, #2563eb) !important;
          }
          .rt-msg-id-cell-span i.selected-icon {
            font-size: 12px !important;
            color: var(--task-accent, #2563eb) !important;
          }
          .rt-form-cell-wrapper {
            display: flex !important;
            flex-direction: column !important;
            gap: 6px !important;
          }
          .rt-status-tags-wrapper {
            display: flex !important;
            align-items: center !important;
            gap: 8px !important;
            flex-wrap: wrap !important;
          }
          .rt-status-tags-wrapper .rt-form-status-tag {
            height: 24px !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 4px !important;
          }
          .rt-status-tags-wrapper .rt-form-status-tag i {
            font-size: 10px !important;
          }
          .rt-form-action-btn.is-notes-btn {
            min-width: auto !important;
            padding: 6px 12px !important;
            font-size: 11.5px !important;
          }
          /* NotesPopover styles are now in ../../comman/NotesPopover.jsx */
          .rt-form-buttons-row .rt-form-action-btn.is-send,
          .rt-form-buttons-row .rt-form-action-btn.is-allow,
          .rt-form-buttons-row .rt-action-label-badge.is-sent {
            height: 32px !important;
            padding: 0 12px !important;
            font-size: 11.5px !important;
            min-width: 80px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
          .rt-form-buttons-row .rt-form-action-btn.is-delete {
            height: 32px !important;
            width: 32px !important;
            padding: 0 !important;
            min-width: auto !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
        `}</style>

        <div className="rt-msg-tab-bar">
          <button
            type="button"
            className={`rt-msg-tab-btn${selectedKey === "home" ? " active" : ""}`}
            onClick={() => handleSelectTab("home")}
          >
            <i className="fa fa-folder-open" aria-hidden="true" />
            Forms
            <span className="rt-msg-tab-badge">{appFormLibrary.length}</span>
          </button>
          <button
            type="button"
            className={`rt-msg-tab-btn${selectedKey === "profile" ? " active" : ""}`}
            onClick={() => handleSelectTab("profile")}
          >
            <i className="fa fa-file-text-o" aria-hidden="true" />
            {selectedFormId > 0 ? "Edit" : "Add"} Form
          </button>
        </div>

        {selectedKey === "home" && (
          <div className="rt-msg-panel">
            {renderSelectedFormCard()}
            <div className="table-responsive rt-msg-table-scroll">
              <table className="table align-items-center table-flush rt-msg-table">
                <thead>
                  {isLoading && (
                    <tr style={{ height: "0px", padding: 0 }}>
                      <th colSpan={5} style={{ padding: 0, border: "none", height: "0px", position: "relative" }}>
                        <div className="wf-loading-bar" />
                      </th>
                    </tr>
                  )}
                  <tr>
                    <th>
                      <div className="rt-th-id-wrapper">
                        <span>ID</span>
                        {selectedFormId > 0 && (
                          <span
                            className="rt-id-reset-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleResetSelection();
                            }}
                            title="Reset Selection"
                          >
                            <i className="fa fa-refresh" aria-hidden="true" />
                          </span>
                        )}
                      </div>
                    </th>
                    <th>Created</th>
                    <th>Sender Details</th>
                    <th>Form</th>
                    <th>Notes</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    Array.from({ length: 5 }).map((_, i) => (
                      <tr key={`skel-${i}`} className="skeleton-row">
                        <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                        <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                        <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                        <td><span className="skeleton-cell sk-full" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                        <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.04}s` }} /></td>
                        <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                      </tr>
                    ))
                  ) : appFormLibrary.length === 0 ? (
                    <tr>
                      <td colSpan={6} style={{ padding: 0 }}>
                        <div className="rt-msg-empty-state">
                          <div className="rt-msg-empty-icon">
                            <i className="fa fa-folder-open-o" aria-hidden="true" />
                          </div>
                          <p className="rt-msg-empty-title">No Forms in Library</p>
                          <p className="rt-msg-empty-desc">
                            Forms added for the applicant will appear here.
                          </p>
                          <button
                            className="rt-msg-action-btn is-primary"
                            type="button"
                            onClick={() => handleSelectTab("profile")}
                            style={{ marginTop: "12px" }}
                          >
                            <i className="fa fa-plus" aria-hidden="true" /> Add Form
                          </button>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    appFormLibrary.map((f, key) => {
                      const isSelected = selectedFormId === f.id;
                      const hasEditPermission = f.allowEdit === 1;
                      const hasEditRequest = f.allowEdit === 2;
                      const isSent = f.sendStatus;
                      const isUpdated = f.updatedCount > 0;

                      return (
                        <tr
                          key={f.id}
                          className={`rt-msg-row ${isSelected ? "selected-row" : ""}`}
                          onClick={() => handleSelectForm(f)}
                          style={{ animationDelay: `${key * 0.04}s` }}
                          title={isSelected ? `Click to deselect: Form #${f.id}` : `Click to select: Form #${f.id}`}
                        >
                          <td>
                            <span className="rt-msg-id-cell-span">
                              {isSelected && (
                                <i className="fa fa-check-circle selected-icon" />
                              )}
                              #{f.id}
                            </span>
                          </td>
                          <td>
                            <div className="rt-msg-time">
                              <div className="rt-msg-time-row">
                                <span className="rt-msg-time-icon">
                                  <i className="fa fa-calendar-o" aria-hidden="true" />
                                </span>
                                <span className="rt-msg-time-date">
                                  <Moment format="MMM D, YYYY">{f.createdDateTime}</Moment>
                                </span>
                              </div>
                              <span className="rt-msg-time-subtext">
                                <Moment format="h:mm a">{f.createdDateTime}</Moment>
                              </span>
                            </div>
                          </td>
                          <td>
                            <div className="wf-name-cell">
                              <span className="wf-name-avatar">
                                {(f.performerName || "System").split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase()}
                              </span>
                              <div className="wf-name-meta">
                                <span className="wf-name-main">{f.performerName || "System"}</span>
                                {f.performerRole ? (
                                  <span className="wf-name-title">{f.performerRole}</span>
                                ) : (
                                  <span className="wf-name-title">System</span>
                                )}
                                {f.email && (
                                  <span className="rt-msg-email" title={f.email}>
                                    <i className="fa fa-envelope-o" aria-hidden="true" /> {f.email}
                                  </span>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="rt-form-cell-wrapper">
                              <div>
                                <button
                                  type="button"
                                  className="rt-form-name-link"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewFormShowHide(f);
                                  }}
                                >
                                  <span className="rt-form-name-text">{f.formName}</span>
                                  {f.updatedCount > 0 && (
                                    <span className="rt-action-badge">{f.updatedCount}</span>
                                  )}
                                </button>
                              </div>
                              <div className="rt-status-tags-wrapper" onClick={(e) => e.stopPropagation()}>
                                <span className={`rt-form-status-tag ${isUpdated ? "is-updated" : "is-pending"}`}>
                                  {isUpdated ? "Updated" : "Pending"}
                                </span>

                                {hasEditPermission && (
                                  <span className="rt-form-status-tag is-allowed">
                                    <i className="fa fa-check-circle" aria-hidden="true" /> Edit Allowed
                                  </span>
                                )}

                                {hasEditRequest && (
                                  <span className="rt-form-status-tag is-requested">
                                    <i className="fa fa-exclamation-circle" aria-hidden="true" /> Req Received
                                  </span>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            {f.remarks ? (
                              getPopover(f.remarks, key === 0 ? "bottom" : "top")
                            ) : (
                              <span className="wf-empty-value">No remarks</span>
                            )}
                          </td>
                          <td>
                            <div className="rt-form-buttons-row" onClick={(e) => e.stopPropagation()}>
                              {isSent ? (
                                <span className="rt-action-label-badge is-sent">
                                  <i className="fa fa-paper-plane-o" aria-hidden="true" /> Sent
                                </span>
                              ) : (
                                <button
                                  type="button"
                                  className="rt-form-action-btn is-send"
                                  onClick={() => handleSendForm(f.id)}
                                  disabled={isSendLoading && sendingFormId === f.id}
                                >
                                  {isSendLoading && sendingFormId === f.id ? (
                                    <><i className="fa fa-spinner fa-spin" aria-hidden="true" /> Sending...</>
                                  ) : (
                                    <><i className="fa fa-paper-plane" aria-hidden="true" /> Send</>
                                  )}
                                </button>
                              )}

                              {!hasEditPermission && (
                                <button
                                  type="button"
                                  className="rt-form-action-btn is-allow"
                                  onClick={() => handleAllowForm(f, 1)}
                                  title={f.editRemarks || "Allow Edit"}
                                >
                                  <i className={hasEditRequest ? "fa fa-unlock-alt" : "fa fa-unlock"} aria-hidden="true" /> Allow Edit
                                </button>
                              )}

                              <button
                                type="button"
                                className="rt-form-action-btn is-delete"
                                onClick={() => handleDeleteForm(f.id)}
                                title="Delete"
                                disabled={isDeleteLoading && deletingFormId === f.id}
                              >
                                {isDeleteLoading && deletingFormId === f.id ? (
                                  <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                                ) : (
                                  <i className="fa fa-trash-o" aria-hidden="true" />
                                )}
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {selectedKey === "profile" && (
          <div className="rt-msg-panel is-form-panel">
            <AddFormLibrary
              handleAddFormLibrary={handleAddFormLibrary}
              workflowTask={workflowTask}
              selectedForm={selectedForm}
            />
          </div>
        )}
      </div>

      <ViewFormModal
        viewFormShowHide={viewFormShowHide}
        handleViewForm={handleViewFormShowHide}
        workflowTask={workflowTask}
        selectedForm={selectedForm}
      ></ViewFormModal>
    </React.Fragment>
  );
};

export default FormsLibrary;
